import { type ClassValue, clsx } from "clsx";

/**
 * A tiny (239B) utility for constructing className strings conditionally.
 * https://www.npmjs.com/package/clsx?activeTab=readme
 */
export const cn = (...inputs: ClassValue[]) => clsx(inputs);
